import { useEffect, useState } from 'react';
import axios from 'axios';

// URLs from environment variables or fallback
const WEBSOCKET_URL = process.env.REACT_APP_LIVES_WS_URI || 'wss://live-gateway.azurewebsites.net';
const LIVE_URL = (process.env.REACT_APP_LIVES_SERVER_URL || 'https://live-gateway.azurewebsites.net/').replace(/\/$/, '');

export function useTranscript(liveId, isOnLive, info, state, awaitingItem) {
  const [transcripts, setTranscripts] = useState([]);
  const [loadingTranscript, setLoadingTranscript] = useState(false);

  // Fetch archived transcript if not live
  useEffect(() => {
    if (!isOnLive && liveId && info?.TranscriptUrl) {
      setLoadingTranscript(true);
      const plainAxios = axios.create({});

      plainAxios
        .get(info.TranscriptUrl)
        .then((res) => {
          const jsonlData = res.data;
          const transcriptArray = jsonlData
            .split('\n')
            .filter((line) => line.trim() !== '')
            .map((line) => JSON.parse(line));
          setTranscripts(transcriptArray);
          setLoadingTranscript(false);
        })
        .catch((err) => {
          console.error('Error fetching archived transcript:', err);
          setLoadingTranscript(false);
        });
    }
  }, [isOnLive, liveId, info]);

  // While a finished session awaits archiving there is no TranscriptUrl yet, so read the
  // transcript from the live gateway instead.
  useEffect(() => {
    if (!awaitingItem || !liveId || !state || info?.TranscriptUrl) return;

    let active = true;
    setLoadingTranscript(true);
    const plainAxios = axios.create({});

    plainAxios
      .get(`${LIVE_URL}/app/${state}/live/${liveId}`)
      .then((res) => {
        if (!active) return;
        const raw = res.data;
        const items = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
        setTranscripts(items);
        setLoadingTranscript(false);
      })
      .catch(() => {
        if (active) setLoadingTranscript(false);
      });

    return () => {
      active = false;
    };
  }, [awaitingItem, liveId, state, info?.TranscriptUrl]);

  // Open WebSocket for live transcript
  useEffect(() => {
    console.log('isOnLive', isOnLive);
    console.log('liveId', liveId);
    if (isOnLive && liveId) {
      const wsUri = `${WEBSOCKET_URL}/ws?videoId=${liveId}`;
      console.log('wsUri', wsUri);
      const ws = new WebSocket(wsUri);

      ws.onopen = () => {
        console.log('WebSocket connected for transcripts');
      };

      ws.onmessage = (e) => {
        const data = JSON.parse(e.data);
        // Replace full transcript or append new transcript item
        if (data.type === 'fullTranscript') {
          setTranscripts(data.data);
        } else {
          setTranscripts((prev) => [...prev, data]);
        }
      };

      ws.onerror = (err) => {
        console.error('WebSocket error:', err);
      };

      // Cleanup WebSocket on unmount
      return () => ws.close();
    }
  }, [isOnLive, liveId]);

  return { transcripts, loadingTranscript };
}
